import{gql as e}from"@apollo/client";import"../../contexts/ContentPageContext/ContentPageContext.js";import{CONTENT_PAGE_CONTEXT_GRAPHQL as t}from"../../contexts/ContentPageContext/ContentPageContext.graphql.js";import"lodash.isempty";import"lodash.isnil";import"lodash.orderby";import"immer";import"pluralize";import"../../contexts/UserFlowContext/UserFlowContext.js";const n=e`
  query getContentPage($contentPageId: Int!, $userFlowStepTrackId: Int = 0, $withAnswers: Boolean = false) {
    contentPage {
      getContentPage(contentPageId: $contentPageId) {
        ...contentPage
      }
    }
  }

  ${t.fragments.asset}
  ${t.fragments.bubbleText}
  ${t.fragments.contentEvent}
  ${t.fragments.contentEventOnPage}
  ${t.fragments.contentPage}
  ${t.fragments.contentSnippet.app}
  ${t.fragments.contentSnippet.audio}
  ${t.fragments.contentSnippet.avatar}
  ${t.fragments.contentSnippet.button}
  ${t.fragments.contentSnippet.cluster}
  ${t.fragments.contentSnippet.code}
  ${t.fragments.contentSnippet.document}
  ${t.fragments.contentSnippet.embed}
  ${t.fragments.contentSnippet.form}
  ${t.fragments.contentSnippet.image}
  ${t.fragments.contentSnippet.imageMap}
  ${t.fragments.contentSnippet.map}
  ${t.fragments.contentSnippet.question}
  ${t.fragments.contentSnippet.quote}
  ${t.fragments.contentSnippet.slider}
  ${t.fragments.contentSnippet.spacer}
  ${t.fragments.contentSnippet.summary}
  ${t.fragments.contentSnippet.summaryResult}
  ${t.fragments.contentSnippet.text}
  ${t.fragments.contentSnippet.video}
  ${t.fragments.cssStyle}
  ${t.fragments.margin}
  ${t.fragments.questionAnswer.calendar}
  ${t.fragments.questionAnswer.checkbox}
  ${t.fragments.questionAnswer.checkboxResponseCheckbox}
  ${t.fragments.questionAnswer.decimal}
  ${t.fragments.questionAnswer.dropdownList}
  ${t.fragments.questionAnswer.interface}
  ${t.fragments.questionAnswer.match}
  ${t.fragments.questionAnswer.multiLineText}
  ${t.fragments.questionAnswer.multiResponseText}
  ${t.fragments.questionAnswer.multiResponseTextItem}
  ${t.fragments.questionAnswer.number}
  ${t.fragments.questionAnswer.radio}
  ${t.fragments.questionAnswer.rating}
  ${t.fragments.questionAnswer.singleLineText}
  ${t.fragments.questionAnswer.slider}
  ${t.fragments.questionConfigurationMessage}
  ${t.fragments.responseSet}
  ${t.fragments.sectionGroupTab}
  ${t.fragments.summaryFeedbackConfigurationRange}
  ${t.fragments.summaryFeedbackConfigurationRadio}
  ${t.fragments.summaryFeedbackConfigurationMultiResponse}
  ${t.fragments.summaryFeedbackConfigurationRankAndNote}
  ${t.fragments.tag}
`;export{n as GET_CONTENT_PAGE_QUERY};
//# sourceMappingURL=useContentPage.graphql.js.map
